module.exports = __webpack_public_path__ + "img/award.d1b36867.png";